import { useDispatch } from 'react-redux';
import {
  initTaskManager,
  useInitializeTaskManager as useSharedInitializeTaskManager
} from '@make-software/tg-mini-app-ui';

import { useMe, fetchTasks, AppDispatch } from '@/shared';

/**
 * Initialize the task manager once at app startup.
 * This hook should be called once from a high-level component (e.g., ProtectedRoutes).
 */
export const useInitializeTaskManager = () => {
  const me = useMe();
  const dispatch = useDispatch<AppDispatch>();
  const userID = me.data?.user?.auth_user_id ?? undefined;
  const authProvider = me.data?.user?.auth_provider ?? undefined;

  useSharedInitializeTaskManager({
    userID,
    onInitTaskManager: () => dispatch(initTaskManager(window.config.trafficConfig)),
    onFetchTasks: () => {
      if (!userID || !authProvider) return;
      dispatch(fetchTasks({ userID, authProvider }));
    },
    onRefreshUser: () => {
      me.refresh({ withBalances: true });
    }
  });
};
